import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  tabSectionContent: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    marginTop: 36,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 16,
    padding: 16
  },
  maxFields: {
    marginTop: 36,
    background: theme.palette.grey[300],
    borderRadius: 16,
    padding: 16
  },
  saveButton: {
    marginLeft: 12,
    width: 40
  },
  inputs: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 32
  },
  switches: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}))

export default useStyles
